import { getApiBaseUrl } from '../../utils/apiBaseUrl';
import { getUtmParamsForApi } from '../../utils/utmTracker';
import { getWebsiteThemeAttribution } from '../../experiments/websiteTheme';
import { getChallengeGoogleAdsConsent } from '../challenges/challengeQualifyingLead';

export const COURSE_CALENDAR_URL = 'https://calendly.com/lumiwealth/botspot-call';

/** Keep native navigation independent of analytics. This opaque reference
 * connects a later signed booking to the click; it is not a conversion. */
export function trackCourseCalendarClick(event) {
  if (event.button !== 0 && event.button !== 1) return;
  try {
    const link = event.target?.closest?.('a[href]');
    if (!link) return;
    const url = new URL(link.href);
    if (`${url.origin}${url.pathname}` !== COURSE_CALENDAR_URL) return;
    const bookingContextId = window.crypto.randomUUID();
    const body = JSON.stringify({
      ...getUtmParamsForApi(),
      ...getWebsiteThemeAttribution(),
      googleAdsConsent: getChallengeGoogleAdsConsent(),
      posthog_distinct_id: window.posthog?.get_distinct_id?.(),
      landingPage: 'https://botspot.trade/courses/ai-trading-bootcamp',
      bookingContextId,
    });
    url.searchParams.set('utm_source', 'ai_trading_bootcamp');
    url.searchParams.set('utm_campaign', 'ai-trading-bootcamp');
    url.searchParams.set('utm_content', bookingContextId);
    link.href = url.toString();
    // No await, preventDefault or popup. keepalive allows the bounded request
    // to continue when the browser immediately follows the ordinary link.
    void fetch(
      `${getApiBaseUrl() || 'https://api.botspot.trade'}/calendly/course-booking-context`,
      {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body,
      },
    ).catch(() => {});
  } catch {
    // Missing storage, crypto or analytics must never obstruct calendar access.
  }
}
